<template>
  <div class="vld-parent">
    <loading :active.sync="isLoading" :can-cancel="true" :is-full-page="fullPage"></loading>
    <menu-superior :link="'/'+this.$store.state.empresa_url + '/menu'" titulo="MEU PEDIDO"
                   :style="'background-color: ' + this.$store.state.empresa.cor_primaria"></menu-superior>
    <bloco>
      <titulo-destacado titulo="Resumo do seu pedido"></titulo-destacado>

      <div class="tb itens text-bold cor-primaria-divider">
        <span class="tb-fill">ITENS</span>
        <span class="tb-fit">VALOR</span>
      </div>

      <div v-for="(item, index) in this.$store.state.pedido.itens" :key="index">
        <div class="tb itens lista cor-primaria-divider">
          <span class="tb-fill text-bold">
            {{ item.quantidade + "x " + item.produto.nome }}
          </span>
          <span class="tb-fit right">
            R$ {{ (item.produto.valor * item.quantidade).toFixed(2) }}
            <span @click="RemoverItem(item)" class="btn-small materialize-red">
              <i class="material-icons md-18 text-bold">close</i>
            </span>
          </span>
        </div>

        <div v-if="$store.state.empresa.mostrar_categoria_wpp == 'S'">
          <div v-for="(categoria, index) in item.categorias" :key="index">
<!--            {{categoria}}-->
            <span class="tb itens lista cor-primaria-divider text-bold grey-text text-darken-2" style="padding-left: 16px">{{categoria.descricao}}</span>
            <div v-for="(adicional, index) in categoria.adicionais" :key="index" class="tb itens lista cor-primaria-divider">
              <span class="tb-fill" style="padding-left: 16px">
                {{ ((adicional.quantidade || 1) * item.quantidade) + "x " + adicional.nome }}
              </span>
              <span class="tb-fit right">
                R$ {{ (adicional.valor * (adicional.quantidade || 1) * item.quantidade).toFixed(2) }}
                <span @click="RemoverAdicional(item, adicional)" :class="'btn-small materialize-red' + (adicional.obrigatorio == 'S' ? ' disabled': '')">
                  <i class="material-icons md-18" style="font-weight: bold">close</i>
                </span>
              </span>
            </div>
          </div>
        </div>
        <div v-else>
          <div v-for="(adicional, index) in item.adicionais" :key="index" class="tb itens lista cor-primaria-divider">
            <span class="tb-fill" style="padding-left: 16px">
              {{ (adicional.quantidade || 1 * item.quantidade) + "x " + adicional.nome }}
<!--              <br>-->
<!--              {{ adicional }}-->
            </span>
            <span class="tb-fit right">
              R$ {{ (adicional.valor * (adicional.quantidade || 1) * item.quantidade).toFixed(2) }}
              <span @click="RemoverAdicional(item, adicional)" :class="'btn-small materialize-red' + (adicional.obrigatorio == 'S' ? ' disabled': '')">
                <i class="material-icons md-18" style="font-weight: bold">close</i>
              </span>
            </span>
          </div>
        </div>
      </div>

      <div class="tb itens text-bold grey-text text-darken-4 cor-primaria-divider">
        <span class="tb-fill">SUBTOTAL</span>
        <span class="tb-fit">R$ {{ this.$store.getters.pedidoSubtotal.toFixed(2) }}</span>
      </div>

      <div v-if="forma_entrega == 'ENTREGA' && parseFloat(this.$store.state.empresa.taxa_entrega) > 0" class="tb itens grey-text text-darken-2 cor-primaria-divider">
        <span class="tb-fill">Taxa de Entrega</span>
        <span class="tb-fit">R$ {{ parseFloat(this.$store.state.empresa.taxa_entrega).toFixed(2) }}</span>
      </div>

      <div v-if="ObterTaxaRetorno() > 0" class="tb itens grey-text text-darken-2 cor-primaria-divider">
        <span class="tb-fill">Taxa de Retorno</span>
        <span class="tb-fit">R$ {{ ObterTaxaRetorno().toFixed(2) }}</span>
      </div>

      <div v-if="CalcularValorDescontoFormaPagamento() > 0" class="tb itens green-text text-darken-2 cor-primaria-divider">
        <span class="tb-fill">Desconto ({{ forma_pagamento }})</span>
        <span class="tb-fit">- R$ {{ parseFloat(CalcularValorDescontoFormaPagamento()).toFixed(2) }}</span>
      </div>

      <div class="tb itens text-bold grey-text text-darken-4 cor-primaria-divider">
        <span class="tb-fill">TOTAL</span>
        <span class="tb-fit">R$ {{ ObterValorTotalAtualizadoDoPedido() }}</span>
      </div>
    </bloco>

    <div class="content-e">
      <router-link
        :to="'/' + this.$store.state.empresa_url + '/menu'"
        class="waves-effect waves-light btn-small btn-large"
        :style="'background-color: '+this.$store.state.empresa.cor_primaria">Acrescentar mais itens
      </router-link>
    </div>

    <bloco v-if="this.$store.state.empresa.is_modulo_cupom_disponivel">
      <titulo-destacado :fundo="'white'" titulo="Cupom de Desconto?"
                        :style="'border-style: solid;border-width: 1px;border-color: '+ this.$store.state.empresa.cor_primaria+';color:'+ this.$store.state.empresa.cor_primaria"></titulo-destacado>
      <div class="bloco-lista">
          <div class="input-field">
            <input oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);"
                   @input="cupom_desconto_btn = true;cupom_desconto_mensagem = ''"
                   pattern="^[a-zA-Z0-9]+$"
                   id="cupom_desconto_campo"
                   autocomplete="off" type="text" class="validate"
                   placeholder="Código Ativação" maxlength="30" v-model="cupom_desconto">
          </div>
          <span style="font-size: 11px;font-weight: 700;">{{cupom_desconto_mensagem}}</span>
          <div class="waves-effect waves-light btn-small btn-block"
               @click="AplicarDesconto"
               v-if="cupom_desconto.length > 2 && cupom_desconto_btn" :style="'height: 22.4px; line-height: 22.4px; font-size: 12px;background-color: '+this.$store.state.empresa.cor_primaria">Aplicar
          </div>
      </div>
    </bloco>

    <bloco>
      <titulo-destacado :fundo="'white'" titulo="Como deseja receber o pedido?"
                        :style="'border-style: solid;border-width: 1px;border-color: '+ this.$store.state.empresa.cor_primaria+';color:'+ this.$store.state.empresa.cor_primaria"></titulo-destacado>
      <div class="bloco-lista">
        <div class="col" style="padding-top: 10px">
          <label style="">
            <input name="envio" value="ENTREGA" type="radio" v-model="forma_entrega" />
            <span>Entrega:
                {{
                this.$store.state.empresa.taxa_entrega > 0 ? this.taxa_entrega_v2 : this.$store.state.empresa.empresa_frete_detalhes
              }}
              </span><br>(Podendo haver cobrança de taxas)</span>
          </label>
        </div>

        <div v-if="this.$store.state.empresa.retirar_local == 'S'" class="col" style="padding-top: 10px">
          <label class="grey-text text-darken-4">
            <input name="envio" value="RETIRADA" type="radio" class="with-gap" v-model="forma_entrega"/>
            <span>Retirada<br>(Verificar disponibilidade)</span>
          </label>
        </div>

      </div>
    </bloco>

    <bloco v-if="this.forma_entrega == 'ENTREGA'">
      <titulo-destacado :fundo="'white'" titulo="Endereço de Entrega"
                        :style="'border-style: solid;border-width: 1px;border-color: '+ this.$store.state.empresa.cor_primaria+';color:'+ this.$store.state.empresa.cor_primaria">
        <span v-if="!this.endereco_entrega_valido" class="valid-badge new badge cor-primaria-bg" data-badge-caption=""
              :style="'background-color: '+this.$store.state.empresa.cor_primaria">Obrigatório</span>
        <span v-else class="valid-check material-icons md-38 cor-primaria-text">check_circle_outline</span>
      </titulo-destacado>

      <div class="bloco-lista">
        <div v-for="endoff in enderecos_offline" :key="endoff.bairro_id" class="col" style="padding-top: 8px">
          <div class="row" v-if="endoff">
            <div class="col s10">
              <label class="grey-text text-darken-4">
                <input class="right with-gap" type="radio" :name="endoff" :value="endoff"
                       v-model="endereco_offiline_selecionado" 
                       @change="SelecionarEnderecoSalvo(endoff)"
                       style="display: inherit;"/>
                <span>
                  <strong>{{
                      endoff.endereco + (endoff.numero ? ', ' + endoff.numero : '') + (endoff.complemento ? ', ' + endoff.complemento : '')
                    }}</strong>, {{ endoff.bairro_nome }}, {{ endoff.cidade_nome }}/{{
                    endoff.uf
                  }}{{ endoff.cep ? ', CEP:' + endoff.cep : '' }}
                </span>
              </label>
            </div>
            <div class="col s2">
              <i class="material-icons md-30 materialize-red-text" @click="RemoverEndereco(endoff)">delete_forever</i>
            </div>
          </div>
        </div>
        <div class="content-e col" style="margin-top: 8px">
          <button class="waves-effect waves-light btn-small cor-primaria-bg" @click="NovoEndereco()">
            Novo Endereço
          </button>
        </div>
      </div>
      <hr>

      <div class="bloco-lista" v-if="novo_endereco">
        <div class="row" style="margin-bottom: 0px">
          <div class="input-field col s10" style="padding: 0 10px 0 0;">
            <input
              id="cep"
              placeholder="Digite seu CEP "
              v-model="endereco.cep"
              value=""
              type="number"
              required
              class="validate"
              style="left: 0px;" v-on:input="maxLengthCheck()" v-on:blur="PesquisarCep()">
            <label for="cep" class="grey-text text-darken-4" style="padding-left: 0px; left: 0.01rem"></label>
          </div>
          <div class="col s2" style="padding: 24px 0 0 0;">
            <a @click="PesquisarCep()" class="waves-effect waves-light btn-small cor-primaria-bg"><i
              class="material-icons md-24">search</i></a>
          </div>
        </div>

        <div class="row">
          <div class="input-field col s8" style="padding: 0 0rem 0 0;">
            <input autocomplete="off" id="endereco" v-model="endereco.endereco" type="text" class="validate" required
                   style="left: 0px;" placeholder="Endereço" maxlength="50" @blur="CalcularFrete('')">
            <label for="endereco" class="grey-text text-darken-4" style="padding-left: 0px; left: 0.01rem"></label>
          </div>
          <div class="input-field col s4" style="padding: 0 0.70rem;">
            <input autocomplete="off" id="s_numero" type="number" v-model="endereco.numero" class="validate"
                   placeholder="Número" @blur="CalcularFrete('')">
            <label for="s_numero" class="grey-text text-darken-4"></label>
          </div>
        </div>

        <div class="row" style="margin-bottom: 0px">
          <div class="input-field col s6" style="padding: 0 0rem 0 0;">

            <select autocomplete="off" v-if="this.$store.state.empresa.forma_cobranca_frete == 'BAIRRO'"
                    class="browser-default" @change="CalcularFrete(bairro_id)" v-model="bairro_id">
              <option value="" disabled selected>Selecione um Bairro</option>
              <option v-for="bairrofrete in this.$store.state.empresa.tarifas_entrega_bairro"
                      :key="bairrofrete.bairro_id" :value="bairrofrete.bairro_id">{{ bairrofrete.bairro }}
              </option>
            </select>
            <span v-else>
            <input autocomplete="off" id="bairro" type="text" v-model="endereco.bairro" class="validate" required
                   style="left: 0px;" placeholder="Bairro" maxlength="50" @blur="CalcularFrete('')">
            <label for="bairro" class="grey-text text-darken-4" style="padding-left: 0px; left: 0.01rem"></label>
          </span>

          </div>
          <div class="input-field col s6" style="padding: 0 0.70rem;">
            <input autocomplete="off" id="complemento" v-model="endereco.complemento" type="text" class="validate"
                   placeholder="Complemento" maxlength="150">
            <label for="complemento" class="grey-text text-darken-4"></label>
          </div>
        </div>

        <div class="row">
          <div class="input-field col s12" style="padding: 0 0rem 0 0;">
            <select class="browser-default" v-model="endereco.uf" autocomplete="off" id="estado">
              <option value="AC">Acre</option>
              <option value="AL">Alagoas</option>
              <option value="AP">Amapá</option>
              <option value="AM">Amazonas</option>
              <option value="BA">Bahia</option>
              <option value="CE">Ceará</option>
              <option value="DF">Distrito Federal</option>
              <option value="ES">Espirito Santo</option>
              <option value="GO">Goiás</option>
              <option value="MA">Maranhão</option>
              <option value="MS">Mato Grosso do Sul</option>
              <option value="MT">Mato Grosso</option>
              <option value="MG">Minas Gerais</option>
              <option value="PA">Pará</option>
              <option value="PB">Paraíba</option>
              <option value="PR">Paraná</option>
              <option value="PE">Pernambuco</option>
              <option value="PI">Piauí</option>
              <option value="RJ">Rio de Janeiro</option>
              <option value="RN">Rio Grande do Norte</option>
              <option value="RS">Rio Grande do Sul</option>
              <option value="RO" selected>Rondônia</option>
              <option value="RR">Roraima</option>
              <option value="SC">Santa Catarina</option>
              <option value="SP">São Paulo</option>
              <option value="SE">Sergipe</option>
              <option value="TO">Tocantins</option>
            </select>
          </div>
          <div class="input-field col s12" style="padding: 0 0rem 0 0;">
            <input autocomplete="off" id="cidade" v-model="endereco.cidade_nome" type="text" placeholder="Cidade"
                   class="validate" style="left: 0px;" maxlength="50">
            <label for="cidade" class="grey-text text-darken-4"></label>
          </div>
        </div>
      </div>
    </bloco>

    <bloco>
      <titulo-destacado :fundo="'white'" titulo="Forma de Pagamento"
                        :style="'border-style: solid;border-width: 1px;border-color: '+ this.$store.state.empresa.cor_primaria+';color:'+ this.$store.state.empresa.cor_primaria"></titulo-destacado>
      <div class="bloco-lista">
        <div class="col" style="padding-top: 10px" v-if="this.$store.state.empresa.pagamento_dinheiro == 'S'">
          <label style="">
            <input value="DINHEIRO" type="radio" v-model="forma_pagamento"/>
            <span>Dinheiro <b class="green-text" v-if="ExibirBadgeDesconto('DINHEIRO')">({{ ExibirBadgeDesconto('DINHEIRO') }})</b></span>
          </label>
          <a class="btn right"
             :style="'padding: 4px; margin: 1px;background-color: '+this.$store.state.empresa.cor_primaria"
             v-if="forma_pagamento == 'DINHEIRO'"
             @click="precisa_troco = !precisa_troco">{{
              precisa_troco ? 'Não precisa de troco' : 'Preciso de troco'
            }}</a>
        </div>
        <div class="col" style="padding-top: 10px" v-if="this.$store.state.empresa.pagamento_pix == 'S'">
          <label class="">
            <input value="PIX" type="radio" class="with-gap" v-model="forma_pagamento" @click="precisa_troco = false"/>
            <span>PIX <b class="green-text" v-if="ExibirBadgeDesconto('PIX')">({{ ExibirBadgeDesconto('PIX') }})</b></span>
          </label>
        </div>
        <div class="col" style="padding-top: 10px" v-if="(this.$store.state.empresa.pagamento_paghiper_pix == 'S') && (this.$store.state.empresa.modulo_paghiper_status == 'ATIVO')">
          <label style="">
            <input value="PAGHIPER_PIX" type="radio" class="with-gap" v-model="forma_pagamento"
                   @click="precisa_troco = false"/>
            <span>PIX Online <b class="green-text" v-if="ExibirBadgeDesconto('PAGHIPER_PIX')">({{ ExibirBadgeDesconto('PAGHIPER_PIX') }})</b></span>
          </label>
        </div>
        <div class="col" style="padding-top: 10px"
             v-if="(this.$store.state.empresa.pagamento_mercadopagolink == 'S') && (this.$store.state.empresa.modulo_mercadopago_status == 'ATIVO')">
          <label class="">
            <input value="MERCADOPAGOLINK" type="radio" class="with-gap" v-model="forma_pagamento"
                   @click="precisa_troco = false"/>
            <span>Pagamento com Link Online <b class="green-text" v-if="ExibirBadgeDesconto('MERCADOPAGOLINK')">({{ ExibirBadgeDesconto('MERCADOPAGOLINK') }})</b></span>
          </label>
        </div>
        <div class="col" style="padding-top: 10px" v-if="this.$store.state.empresa.pagamento_debito == 'S'">
          <label style="">
            <input value="DEBITO" type="radio" class="with-gap" v-model="forma_pagamento" @click="precisa_troco = false"/>
            <span>Cartão de Débito <b class="green-text" v-if="ExibirBadgeDesconto('DEBITO')">({{ ExibirBadgeDesconto('DEBITO') }})</b></span>
          </label>
        </div>
        <div class="col" style="padding-top: 10px" v-if="this.$store.state.empresa.pagamento_credito == 'S'">
          <label style="">
            <input value="CREDITO" type="radio" class="with-gap" v-model="forma_pagamento" @click="precisa_troco = false"/>
            <span>Cartão de Crédito <b class="green-text" v-if="ExibirBadgeDesconto('CREDITO')">({{ ExibirBadgeDesconto('CREDITO') }})</b></span>
          </label>
        </div>
        <div class="col" style="padding-top: 10px" v-if="(this.$store.state.empresa.pagamento_softexpress_cartao == 'S') && (this.$store.state.empresa.modulo_softexpress_status == 'ATIVO')">
          <label>
            <input value="SOFTEXPRESS_CARTAO" type="radio" class="with-gap" v-model="forma_pagamento"
                   @click="precisa_troco = false"/>
            <span>Cartão de Crédito Online <b class="green-text" v-if="ExibirBadgeDesconto('SOFTEXPRESS_CARTAO')">({{ ExibirBadgeDesconto('SOFTEXPRESS_CARTAO') }})</b></span>
          </label>
        </div>
        <div class="col" style="padding-top: 10px" v-if="this.$store.state.empresa.pagamento_transferencia == 'S'">
          <label class="">
            <input value="TRANSFERENCIA" type="radio" class="with-gap" v-model="forma_pagamento"
                   @click="precisa_troco = false"/>
            <span>Transferência <b class="green-text" v-if="ExibirBadgeDesconto('TRANSFERENCIA')">({{ ExibirBadgeDesconto('TRANSFERENCIA') }})</b></span>
          </label>
        </div>
        <div class="col" style="padding-top: 10px" v-if="this.$store.state.empresa.pagamento_boleto == 'S'">
          <label class="">
            <input value="BOLETO" type="radio" class="with-gap" v-model="forma_pagamento"
                   @click="precisa_troco = false"/>
            <span>Boleto <b class="green-text" v-if="ExibirBadgeDesconto('BOLETO')">({{ ExibirBadgeDesconto('BOLETO') }})</b></span>
          </label>
        </div>
      </div>
    </bloco>

    <bloco v-if="precisa_troco">
      <titulo-destacado :fundo="'white'" titulo="Troco para quanto?"
                        :style="'border-style: solid;border-width: 1px;border-color: '+ this.$store.state.empresa.cor_primaria+';color:'+ this.$store.state.empresa.cor_primaria">
        <span v-if="!this.troco_valido" class="valid-badge new badge cor-primaria-bg" data-badge-caption=""
              :style="'background-color: '+this.$store.state.empresa.cor_primaria">Obrigatório</span>
        <span v-else class="valid-check material-icons md-38 cor-primaria-text">check_circle_outline</span>
      </titulo-destacado>
      <div class="bloco-lista">
        <div class="input-field col s8" style="padding: 0 0rem 0 0;">
          <money id="troco_valor" v-model="troco_para_quanto"></money>
          <label for="troco_valor" class="grey-text text-darken-4" style="padding-left: 0px; left: 0.01rem"></label>
        </div>
      </div>
    </bloco>

    <bloco v-if="this.forma_pagamento == 'PIX'">
      <titulo-destacado :fundo="'white'" titulo="Dados do PIX" :style=" 'border-style: solid;border-width: 1px;border-color: ' + this.$store.state.empresa.cor_primaria +';color:' +this.$store.state.empresa.cor_primaria">
      </titulo-destacado>

      <div class="bloco-lista">
        <div class="col" style="padding-top: 8px">
          <div class="row">
            <div class="col s12">
              <label class="grey-text text-darken-4">
                <span>
                  <strong>PIX - Tipo:</strong> &nbsp;&nbsp; {{ this.$store.state.empresa.pagamento_pix_chave_tipo }}
                  <span>
                    <br><br>
                    <strong>PIX - Chave Pagamento:</strong> <hr>
                    <input type="text" :value="this.$store.state.empresa.pagamento_pix_chave" id="myInput" readonly>
                    <button @click="myFunction()">Copiar</button>
                  </span>
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>

    </bloco>

    <bloco>
      <titulo-destacado :fundo="'white'" titulo="Informe seus dados"
                        :style="'border-style: solid;border-width: 1px;border-color: '+ this.$store.state.empresa.cor_primaria+';color:'+ this.$store.state.empresa.cor_primaria">
        <span v-if="!this.dados_pessoa_valido" class="valid-badge new badge cor-primaria-bg" data-badge-caption=""
              :style="'background-color: '+this.$store.state.empresa.cor_primaria">Obrigatório</span>
        <span v-else class="valid-check material-icons md-38 cor-primaria-text">check_circle_outline</span>
      </titulo-destacado>
      <div class="bloco-lista">
        <div class="input-field col s8" style="padding: 0 0rem 0 0;">
          <input id="nome_cliente" v-model="nome_cliente" type="text" class="validate" style="left: 0px;"
                 placeholder="Seu nome...">
          <label for="nome_cliente" style="padding-left: 0px; left: 0.01rem"></label>
        </div>

        <div class="input-field col s8" style="padding: 0 0rem 0 0;">
          <the-mask id="telefone" v-model="telefone" type="tel" :masked="true"
                    :mask="['(##) ####-####','(##) #####-####']" placeholder="Seu Telefone..."/>
          <label for="telefone" style="padding-left: 0px; left: 0.01rem"></label>
        </div>

        <div class="" v-if="this.$store.state.empresa.perguntar_cpf_nota == 'S'">
          <div class="col ">
            <div class="switch">
              <label>
                CPF na nota?
                <input type="checkbox" v-model="cpf_nota">
                <span class="lever"></span>
              </label>
            </div>
          </div>
        </div>

        <div class="input-field col s8" style="padding: 0 0rem 0 0;" v-if="cpf_nota">
          <the-mask id="cpf" v-model="cpf" t :mask="['###.###.###-##']" placeholder="Seu CPF..."/>
          <label for="cpf" style="padding-left: 0px; left: 0.01rem"></label>
        </div>

      </div>
    </bloco>

    <bloco v-if="this.forma_pagamento == 'SOFTEXPRESS_CARTAO'" id="SOFTEXPRESS_CARTAO_CAIXA_PAGAMENTO" >
      <div class="bloco">
        <div class="input-field" style="padding: 0 0rem 0 0;">
          <titulo-destacado :fundo="'white'" titulo="Pagamento Cartão Online" :style=" 'border-style: solid;border-width: 1px;border-color: ' + this.$store.state.empresa.cor_primaria +';color:' +this.$store.state.empresa.cor_primaria">
              <span
                class="valid-badge new badge cor-primaria-bg"
                data-badge-caption=""
                :style="'background-color: ' + this.$store.state.empresa.cor_primaria"
              >Obrigatório</span
              >
          </titulo-destacado>
          <SoftwareExpressCheckoutTransparente></SoftwareExpressCheckoutTransparente>
          <center>
            <strong style="color: #bdbdbd;font-size: 12px;">Aguardando pagamento...</strong><br>
            <img height="100" src="@/assets/aguardando.gif"/>
          </center>
        </div>
      </div>
    </bloco>

    <bloco v-if="this.forma_pagamento == 'PAGHIPER_PIX'" id="PAGHIPER_PIX_CAIXA_PAGAMENTO" style="display: none">
      <div class="bloco">
        <titulo-destacado :fundo="'white'" titulo="Dados do PIX Online" :style=" 'border-style: solid;border-width: 1px;border-color: ' + this.$store.state.empresa.cor_primaria +';color:' +this.$store.state.empresa.cor_primaria">
          <span class="valid-check material-icons md-38 cor-primaria-text">check_circle_outline</span>
        </titulo-destacado>
        <div class="bloco-lista">
          <div class="col" style="padding-top: 8px">
            <div class="row">
              <div class="col s12">
                <label class="grey-text text-darken-4">
                  <span>
                    <span>
                      <center>
                        <div class=" max-width: 100%;">
                          <p style="padding: 5px; word-wrap: break-word;font-size: small; user-select: text;">
                            {{ this.paghiper_pix.codigo_copia_cola }}
                          </p>
                        </div>
                        <button @click="CopiarParaAreaDeTransferenciaChavePix()">Copiar Código </button>
                        <br>
                        <img style="padding-top: 7px;max-width: 75%" alt="Código pagamento PIX Online"
                            :src="'data:image/png;base64,' + this.paghiper_pix.imagem_qrcode"/>
                    </center>
                    </span>
                    <center>
                        <strong style="color: #bdbdbd;font-size: 12px;">Aguardando pagamento...</strong><br>
                        <img height="100" src="@/assets/aguardando.gif"/>
                    </center>
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </bloco>


    <br>
      <br>
      <br>
      <br>

    <caixa-flutuante-inferior v-if="this.forma_pagamento == 'SOFTEXPRESS_CARTAO'" altura="70" estilo="width: 100%; background-color: white; font-weight: bold; max-width: 800px; padding: .5em">
        <a @click="RealizarPagamentoSoftExpressCartao()" style="width: 100%" id="confirmarPagamentoCartaoOnlineSoftwareExpress"
           :class="'waves-effect waves-light btn-large btn-enviar cor-primaria-bg' + (!PedidoValido() || this.softexpress_cartao.pagamento_realizado ? ' disabled' : '')">
          <span>Confirmar Pagamento</span> R$ {{ ObterValorTotalAtualizadoDoPedido() }}
        </a>
    </caixa-flutuante-inferior>
    <caixa-flutuante-inferior v-else-if="forma_pagamento == 'PAGHIPER_PIX' && this.paghiper_pix.pagamento_realizado == false" altura="70"
                                estilo="width: 100%; background-color: white; font-weight: bold; max-width: 800px; padding: .5em">
        <a @click="RealizarPagamentoPagHiperPix()" style="width: 100%"
           :class="'waves-effect waves-light btn-large btn-enviar cor-primaria-bg' + (!PedidoValido() || this.paghiper_pix.gerado ? ' disabled' : '')">
          <span>{{ this.paghiper_pix.gerado ? 'Aguardando' : 'Realizar' }} Pagamento</span> R$ {{ ObterValorTotalAtualizadoDoPedido() }}
        </a>
    </caixa-flutuante-inferior>
    <caixa-flutuante-inferior v-else altura="70" style="background-color: white">
      <a v-if="!PedidoValido()" class="waves-effect waves-light btn-large disabled" style="width: 100%">Enviar Pedido
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
          style="font-weight: 700">R$ {{ ObterValorTotalAtualizadoDoPedido() }}</span></a>
      <a v-if="PedidoValido()" :class="'waves-effect waves-light btn-large btn-enviar cor-primaria-bg' + (!PedidoValido() ? ' disabled' : '')" @click="EnviarPedido()"
         :style="'width: 100%;background-color:' + this.$store.state.empresa.cor_primaria">Enviar Pedido &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
        style="font-weight: 700">R$ {{ ObterValorTotalAtualizadoDoPedido() }}</span></a>
    </caixa-flutuante-inferior>

  </div>
</template>

<script>
import MenuSuperior from "../Widgets/MenuSuperior";
import Bloco from "../Widgets/Bloco";
import TituloDestacado from "../Widgets/TituloDestacado";
import CaixaFlutuanteInferior from "../Widgets/CaixaFlutuanteInferior";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Swal from 'sweetalert2'
import {WMCompose, WMSend} from '@aninga/whatsapp-manager'
import {ValidarCPF} from 'validadorjs';
import axios from 'axios';
import SecureLS from "secure-ls";
import {
  CalcularFretePorBairroId,
  ObterBairroIdPorBairroNome, ObterBairroPorBairroId,
  ObterEnderecoPorCep, ObterValorFretePorPeso,
  ValidarCEP,
  ObterValorFretePorKm
} from "../../services/frete";
import {SalvarEnderecoClienteNoNavegador, SalvarInformacoesDoClienteNoNavegador} from "../../services/storage";
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import SoftwareExpressCheckoutTransparente from "../Widgets/SoftwareExpressCheckoutTransparente.vue";

export default {
  name: "Pedido",
  data() {
    return {
      showDescricaoValorEntrega: this.$store.state.empresa.taxa_entrega > 0 ? this.taxa_entrega_v2 : this.$store.state.empresa.empresa_frete_detalhes,
      cupom_desconto:'',
      cupom_desconto_btn:true,
      cupom_desconto_mensagem:'',
      link_pagamento: '',
      link_pagamento_chave_rastreamento: '',
      pedido_enviado: false,
      taxa_entrega_v2: '',
      bairro_id: "",
      nao_tem_cep: false,
      nome_cliente: '',
      precisa_troco: false,
      cpf_nota: false,
      cpf: '',
      telefone: '',
      troco_para_quanto: 0,
      forma_pagamento: 'DINHEIRO',
      forma_entrega: 'ENTREGA',
      endereco: {
        cep: '',
        endereco: '',
        numero: '',
        bairro: '',
        complemento: '',
        uf: 'RO',
        cidade_nome: '',
        salvo_local: false
      },
      isLoading: false,
      fullPage: true,
      enderecos_offline: [
        {
          cep: '',
          endereco: '',
          numero: '',
          bairro: '',
          bairro_id: '',
          complemento: '',
          uf: '',
          cidade_nome: '',
        }
      ],
      endereco_offiline_selecionado: null,
      novo_endereco: false,
      endereco_entrega_valido: false,
      troco_valido: false,
      dados_pessoa_valido: false,
      groups: [],
      softexpress_cartao:{
        pagamento_realizado: false,
        pagamento_chave_rastreamento:""
      },
      _paghiper_checar_pagamento_intervalo: null,
      paghiper_pix:{
        gerado: false,
        pagamento_realizado: false,
        codigo_copia_cola: "",
        imagem_qrcode: "",
        chave_rastreamento:""
      }
    }
  },
  components: {CaixaFlutuanteInferior, TituloDestacado, Bloco, MenuSuperior, Loading, VueGoogleAutocomplete, SoftwareExpressCheckoutTransparente},
  mounted() {

    console.log(this.$store.state.pedido.itens)
    if (this.$store.state.empresa.mostrar_categoria_wpp == "S") {
      this.$store.state.pedido.itens.forEach(item => {
        item.categorias = _.chain(item.adicionais)
          .groupBy((item) => ( item.produto_adicional_cat_id + "[QUEBRA]" + item.cat_nome) )
          .map((value, key) => ({ descricao: key.split("[QUEBRA]")[1], adicionais: value }))
          .value();
      });
    }


    window.scrollTo(0, 0);
    $(document).ready(function () {
      $('select').formSelect();
    });
    if (this.$store.state.pedido.itens.length == 0) {
      this.$router.push('/' + this.$router.currentRoute.params.empresa + '/menu')
    }

    if (this.$store.state.empresa.forma_cobranca_frete != 'BAIRRO') {
      this.taxa_entrega_v2 = this.$store.state.empresa.taxa_entrega;
      if (this.taxa_entrega_v2 == "0.00") {
        this.taxa_entrega_v2 = "A combinar";
      }
    } else {
      this.$store.state.empresa.taxa_entrega = 0;
    }
    //carregar enderecos offline
    var ls = new SecureLS();
    var enderecos = ls.get('enderecos');
    this.enderecos_offline = enderecos;

    var dados_cliente = ls.get('dados_cliente');
    if (dados_cliente) {
      this.nome_cliente = dados_cliente.nome_cliente;
      this.telefone = dados_cliente.telefone;
      this.cpf_nota = dados_cliente.cpf_nota;
      this.cpf = dados_cliente.cpf;
    }

    $('#cupom_desconto_campo').on('keypress', function (event) {
      var regex = new RegExp("^[a-zA-Z0-9]+$");
      var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
      if (!regex.test(key)) {
        event.preventDefault();
        return false;
      }
    });

    this.$store.state.cupom_desconto_valor = 0.00;
    if(this.$store.state.cupom_desconto){
      this.cupom_desconto = this.$store.state.cupom_desconto;
      this.AplicarDesconto();
    }

  },
  methods: {
    CopiarParaAreaDeTransferenciaChavePix() {
      const input = document.createElement('input');

      if(this.forma_pagamento == 'PAGHIPER_PIX')
        input.value = this.paghiper_pix.codigo_copia_cola;

      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      alert('Código copiado! Aguardando pagamento...');
    },
    FormatarFormaPagamento(forma) {
      let formaPagemento = forma;
      switch (formaPagemento) {
        case 'VALE_ALIMENTACAO':
          formaPagemento = 'Vale Alimentação'
          break;
        case 'VALE_REFEICAO':
          formaPagemento = 'Vale Refeição'
          break;
        case 'PAGHIPER_PIX':
          formaPagemento = 'PIX Online'
          break;
        case 'SOFTEXPRESS_CARTAO':
          formaPagemento = 'Cartão de Crédito - Final: ***' + $('#softwareExpressNumero').val().slice(-4)
          break;
      }
      return formaPagemento;
    },
    SelecionarEnderecoSalvo(endoff) {
      this.LimparEndereco();
      this.endereco.endereco = endoff.endereco;
      this.endereco.numero = endoff.numero;
      this.endereco.bairro = endoff.bairro_nome;
      this.endereco.uf = endoff.uf;
      this.endereco.cidade_nome = endoff.cidade_nome;
      //this.CalcularFrete(endoff.bairro_nome);
      this.CalcularFrete(endoff.bairro_nome);

    },
    ObterTaxaRetorno() {
      const taxa = parseFloat(this.$store.state.empresa.taxa_retorno);
      if (!taxa || taxa <= 0) return 0;
      if (this.forma_entrega !== 'ENTREGA') return 0;
      if (this.forma_pagamento === 'DINHEIRO') return this.precisa_troco ? taxa : 0;
      if (this.forma_pagamento === 'CREDITO' || this.forma_pagamento === 'DEBITO') return taxa;
      return 0;
    },
    ObterValorTotalAtualizadoDoPedido() {
      let subtotalComCupom = parseFloat(this.$store.getters.getValorTotalPedido);
      let taxaEntrega = this.forma_entrega == 'ENTREGA' ? parseFloat(this.$store.state.empresa.taxa_entrega) : 0;
      let taxaRetorno = this.ObterTaxaRetorno();
      let descontoFormaPagamento = parseFloat(this.CalcularValorDescontoFormaPagamento());
      return (subtotalComCupom + taxaEntrega + taxaRetorno - descontoFormaPagamento).toFixed(2);
    },
    RealizarPagamentoPagHiperPix() {
      this.isLoading = true;
      $.ajax({
        url: this.$store.state.apiUrl + "empresa/" + this.$store.state.empresa_url + '/pagamento/pix-paghiper/' + this.ObterValorTotalAtualizadoDoPedido(),
        type: "GET",
        success: (data) => {
          this.paghiper_pix.gerado = true;
          this.paghiper_pix.codigo_copia_cola = data.codigo_copia_cola;
          this.paghiper_pix.imagem_qrcode = data.imagem_qrcode;
          this.paghiper_pix.chave_rastreamento = data.chave_rastreamento;
          this.isLoading = false;
          $("#PAGHIPER_PIX_CAIXA_PAGAMENTO").show();
          setTimeout(() => {
            document.getElementById("PAGHIPER_PIX_CAIXA_PAGAMENTO").scrollIntoView({behavior: 'smooth'});

            this._paghiper_checar_pagamento_intervalo = setInterval(this.ConsultarStatusPagamentoPagHiper, 15000);
            setTimeout(() => {
              clearInterval(this._paghiper_checar_pagamento_intervalo);
              console.log("Intervalo interrompido após um período.");
            }, 300000);

          }, 500);
        },
        error: (data) => {
          this.isLoading = false;
          this.paghiper_pix.gerado = false;
          let erro = "Erro ao gerar PIX para pagamento :(";
          if (data.status < 500 && data.responseJSON.length > 0) {
            erro = data.responseJSON[0];
          }
          Swal.fire({
            title: 'Aviso!',
            text: erro,
            icon: 'error',
            customClass: {confirmButton: 'confirm-button-class materialize-red'}
          });
        }
      });
    },
    RealizarPagamentoSoftExpressCartao()
    {
      this.isLoading = true;
      $.ajax({
            url: this.$store.state.apiUrl + "empresa/" + this.$store.state.empresa_url + '/pagamento/cartao-softexpress',
            data: {
              softwareExpressNome: $('#softwareExpressNome').val(),
              softwareExpressMesAno: $('#softwareExpressMesAno').val(),
              softwareExpressNumero: $('#softwareExpressNumero').val(),
              softwareExpressCVC: $('#softwareExpressCVC').val(),
              softwareExpressBandeira: $('#softwareExpressBandeira').val(),
              softwareExpressValor: this.ObterValorTotalAtualizadoDoPedido(),
            },
            type: "POST",
            success: (data) => {
              this.isLoading = false;
              this.softexpress_cartao.pagamento_chave_rastreamento = data.chave_rastreamento;
              this.softexpress_cartao.pagamento_realizado = true;
              this.EnviarPedido()
            },
            error: (data) => {
              this.isLoading = false;
              var erro = "Erro ao realizar pagamento";
              if (data.responseJSON && data.responseJSON.message) {
                  erro = data.responseJSON.message;
              }
              Swal.fire({
                title: 'Aviso!',
                text: erro,
                icon: 'error',
                customClass: {confirmButton: 'confirm-button-class materialize-red'}
              });
          }
      });
    },
    ConsultarStatusPagamentoPagHiper() {
      let chaveRastreamento = this.paghiper_pix.chave_rastreamento;
      $.ajax({
        url: this.$store.state.apiUrl + "paghiper/consultar-pagamento-pix/" + chaveRastreamento,
        type: "GET",
        success: (data) => {
            if(data.status == 'PAGO'){
              this.paghiper_pix.pagamento_realizado = true;
              clearInterval(this._paghiper_checar_pagamento_intervalo);
              this.EnviarPedido()
            }
        },
        error: (data) => {

        }
      });
    },
    async AplicarDesconto(){
      let codigoAtivacao = this.cupom_desconto;
      let localizacao  = localStorage.getItem('localizacao');
      this.isLoading = true;
      this.cupom_desconto_btn = false;
      await axios
        .get(this.$store.state.apiUrl + "cupom-desconto/pre-ativar?empresa=" + this.$store.state.empresa_url + "&subtotal="+ this.$store.getters.pedidoSubtotal.toFixed(2) +"&codigo_ativacao="+ this.cupom_desconto +"&localizacao=" + localizacao)
        .then(res => {
          if (res.data) {
            this.isLoading = false;
            console.log(res.data);
            this.$store.state.cupom_desconto_valor = res.data;
            this.cupom_desconto_mensagem = 'Cupom aplicado: Valor R$ ' + res.data;
          }
        })
        .catch(error => {
          this.cupom_desconto_mensagem = error.response.data;
          this.isLoading = false;
        });
    },
    ObterChaveDesconto(forma) {
      if (forma == 'PAGHIPER_PIX') return 'PIX';
      if (forma == 'SOFTEXPRESS_CARTAO' || forma == 'MERCADOPAGOLINK') return 'CREDITO';
      return forma;
    },
    ObterDadosDescontoFormaPagamento(forma) {
      if (this.$store.state.empresa.desconto && this.$store.state.empresa.desconto[forma]) {
        let desconto = this.$store.state.empresa.desconto[forma];
        if (desconto.ativo == 'S' && desconto.valor > 0) {
          return desconto;
        }
      }
      return null;
    },
    ObterSubtotalElegivelDesconto() {
      let subtotalElegivel = 0;
      this.$store.state.pedido.itens.forEach(item => {
        if (item.produto.promocao !== 'S') {
          let valorAdicional = 0.00;
          if (item.adicionais) {
            item.adicionais.forEach(adicional => {
              if (adicional) {
                valorAdicional += parseFloat(adicional.valor) * (adicional.quantidade || 1);
              }
            });
          }
          subtotalElegivel += (parseFloat(item.produto.valor) + valorAdicional) * item.quantidade;
        }
      });
      return subtotalElegivel;
    },
    CalcularValorDescontoFormaPagamento() {
      let chave = this.ObterChaveDesconto(this.forma_pagamento);
      let desconto = this.ObterDadosDescontoFormaPagamento(chave);
      if (desconto) {
        let subtotalElegivel = this.ObterSubtotalElegivelDesconto();
        if (subtotalElegivel === 0) return 0;

        if (desconto.forma_desconto == 'PERCENTUAL') {
          return (subtotalElegivel * (desconto.valor / 100));
        } else {
          return desconto.valor > subtotalElegivel ? subtotalElegivel : desconto.valor;
        }
      }
      return 0;
    },
    ExibirBadgeDesconto(forma) {
      let chave = this.ObterChaveDesconto(forma);
      let desconto = this.ObterDadosDescontoFormaPagamento(chave);
      if (desconto) {
        let subtotalElegivel = this.ObterSubtotalElegivelDesconto();
        if (subtotalElegivel === 0) return "";

        let texto = "";
        if (desconto.forma_desconto == 'PERCENTUAL') {
          texto = "-" + desconto.valor + "%";
        } else {
          texto = "- R$ " + parseFloat(desconto.valor).toFixed(2);
        }
        return texto;
      }
      return "";
    },
    CalcularFrete(parametro) {
      this.isLoading = true;
      if ((this.$store.state.empresa.forma_cobranca_frete == 'BAIRRO') && (parametro != '')) {
        if (Number.isInteger(parametro)) {
          this.$store.state.empresa.taxa_entrega = CalcularFretePorBairroId(this.$store.state.empresa.tarifas_entrega_bairro, parametro)
          this.taxa_entrega_v2 = this.$store.state.empresa.taxa_entrega;

          var bairro = ObterBairroPorBairroId(this.$store.state.empresa.tarifas_entrega_bairro, parametro);
          this.endereco.uf = bairro.uf;
          this.endereco.cidade_nome = bairro.cidade;
          this.endereco.bairro = bairro.bairro;
          this.bairro_id = bairro.bairro_id;
          this.isLoading = false;
          this.taxa_entrega_calculo_mensagem_erro = false;

          M.toast({
            html: 'Taxa de entrega aplicada: R$ ' + this.$store.state.empresa.taxa_entrega,
            displayLength: 5000
          });
        } else {
          this.CalcularFretePorBairroNome(parametro);
        }

      }

      //this.isLoading = false;
      //return;

        if ((this.$store.state.empresa.forma_cobranca_frete == 'KM') || (this.$store.state.empresa.forma_cobranca_frete == 'FIXO_KM')) {

        this.isLoading = true;
        if (this.endereco.endereco && this.endereco.numero && this.endereco.bairro) {

          axios.post(this.$store.state.apiUrl + 'empresa/calcular-frete-por-geolocalizacao', {
            "empresa_usuario": this.$store.state.empresa.usuario_url,
            "endereco_entrega": this.endereco.endereco + ', ' + (this.endereco.numero || '') + ' - ' + this.endereco.bairro + ', ' + this.endereco.cidade_nome
          }).then(res => {
            this.isLoading = false;
            console.log(res)
            var taxa_frete = parseFloat(res.data.valor_frete).toFixed(2);
            if (this.taxa_entrega_old != taxa_frete) {
              this.$store.state.empresa.taxa_entrega = taxa_frete;
              this.taxa_entrega_old = taxa_frete;
              this.taxa_entrega_v2 = taxa_frete;
              M.toast({
                html: 'Taxa de entrega atualizada: R$ ' + this.$store.state.empresa.taxa_entrega,
                displayLength: 5000
              });
            }
            this.taxa_entrega_calculo_mensagem_erro = false;
          }).catch(error => {
            this.isLoading = false;
            M.toast({html: "<strong class='red-text'>Endereço inválido</strong>", displayLength: 4000});
            this.taxa_entrega_calculo_mensagem_erro = true;
            if (error.response.status == 404) {
              this.desativarEntrega(error.response.data)
            } else {
              M.toast({html: "<strong class='red-text'>" + error.response.data + "</strong>", displayLength: 4000});
            }
            return null;

          });
        }else{
          this.isLoading = false;
        }
      }

      if (this.$store.state.empresa.forma_cobranca_frete == 'TABELA_KM') {
        this.isLoading = true;
        if (this.endereco.endereco && this.endereco.numero && this.endereco.bairro) {
          axios.post(this.$store.state.apiUrl + 'empresa/calcular-distancia-entrega', {
            "empresa_usuario": this.$store.state.empresa.usuario_url,
            "endereco_entrega": this.endereco.endereco + ', ' + (this.endereco.numero || '') + ' - ' + this.endereco.bairro + ', ' + this.endereco.cidade_nome
          }).then(res => {
            console.log(res)
            this.taxa_entrega_calculo_mensagem_erro = false;
            this.isLoading = false;
            debugger;
            const valor = ObterValorFretePorKm(this.$store.state.empresa.tarifas_entreg_k_m, res.data.distancia_km);
            var taxa_frete = parseFloat(valor).toFixed(2);
            if (this.taxa_entrega_old != taxa_frete) {
              this.$store.state.empresa.taxa_entrega = taxa_frete;
              this.taxa_entrega_old = taxa_frete;
              this.taxa_entrega_v2 = taxa_frete;
              M.toast({
                html: 'Taxa de entrega atualizada: R$ ' + this.$store.state.empresa.taxa_entrega,
                displayLength: 5000
              });
            }
          }).catch(error => {
            console.log(error)
            this.isLoading = false;
            M.toast({html: "<strong class='red-text'>Endereço inválido</strong>", displayLength: 4000});
            this.taxa_entrega_calculo_mensagem_erro = true;
          });
        } else {
          this.isLoading = false;
        }
      }

      if (this.$store.state.empresa.forma_cobranca_frete == 'FIXO') {
        this.isLoading = false;
        this.taxa_entrega_calculo_mensagem_erro = false;
        // this.taxa_entrega_v2 = this.$store.state.empresa.taxa_entrega;
        // M.toast({
        //   html: 'Taxa de entrega aplicada: R$ ' + this.$store.state.empresa.taxa_entrega,
        //   displayLength: 5000
        // });
      }

      //this.ChegarProdutosSomenteParaRetirada();
      //this.isLoading = false;

      if ((this.$store.state.empresa.forma_cobranca_frete == 'BAIRRO') && (parametro == '')) {
        this.isLoading = false;
      }
      return;


    },
    CalcularFretePorBairroNome(nome_bairro) {
      this.isLoading = true;
      this.bairro_id = ObterBairroIdPorBairroNome(this.$store.state.empresa.tarifas_entrega_bairro, nome_bairro);

      if (this.bairro_id != 0) {
        this.$store.state.empresa.forma_cobranca_frete = 'BAIRRO';
        this.CalcularFrete(this.bairro_id)
      } else {
        if (this.$store.state.empresa.limitar_entregas_regioes_pre_definidas == "S") {
          this.desativarEntrega('Região indisponivel', true);
        } else {
          this.$store.state.empresa.forma_cobranca_frete = 'FIXO';
          M.toast({html: 'Frete a Combinar', displayLength: 5000});
        }
      }
      this.isLoading = false;
    },
    DesativarCAmposEndereco() {
      if (this.$store.state.empresa.forma_cobranca_frete == 'BAIRRO') {
        if (document.getElementById("cidade")) {
          document.getElementById("cidade").disabled = true;
        }
        if (document.getElementById("estado")) {
          document.getElementById("estado").disabled = true;
        }
      }
    },
    PesquisarCep() {
      if (!ValidarCEP(this.endereco.cep))
        return;

      this.isLoading = true;
      ObterEnderecoPorCep(this.endereco.cep).then(response => {

        this.endereco = response;

        this.bairro_id = ObterBairroIdPorBairroNome(this.$store.state.empresa.tarifas_entrega_bairro, response.bairro);

        if (this.bairro_id != 0) {
          if (this.$store.state.empresa.forma_cobranca_frete != 'TABELA_KM') {
            this.CalcularFrete(this.bairro_id)
          }
          // this.endereco = response;
        } else {
          if (this.$store.state.empresa.forma_cobranca_frete == 'BAIRRO') {
            this.desativarEntrega('Região indisponivel', true);
          }
          //M.toast({html: "<strong class='red-text'>Região indisponivel</strong>", displayLength: 4000 });
        }

        this.isLoading = false;

      });
    },
    desativarEntrega(msg, showToast = true) {
      this.isLoading = false;
      this.bairro_id = "";
      this.$store.state.empresa.taxa_entrega = 0.00;
      if (showToast)
        M.toast({html: msg, displayLength: 5000});

      this.LimparEndereco();
      this.forma_entrega = "RETIRADA";
    },
    NovoEndereco() {
      this.LimparEndereco();
      this.novo_endereco = !this.novo_endereco;
      this.endereco_offiline_selecionado = null;
      setTimeout(res => {
        this.DesativarCAmposEndereco()
      }, 500);
      M.toast({html: 'Informe seu endereço 🏠', displayLength: 3000});
    },
    SalvarEndereco() {
      SalvarEnderecoClienteNoNavegador(this.endereco.cep, this.endereco.uf, this.endereco.cidade_nome, this.bairro_id, this.endereco.bairro, this.endereco.endereco, this.endereco.numero, this.endereco.complemento)
    },
    SalvarDados() {
      SalvarInformacoesDoClienteNoNavegador(this.nome_cliente, this.telefone, this.cpf_nota, this.cpf);
    },
    RemoverEndereco(itemRemover) {
      Swal.fire({
        title: 'Aviso',
        text: " Deseja realmente remover este endereço ?",
        icon: 'warning',
        customClass: {
          confirmButton: 'confirm-button-class cor-primaria-bg'
        },
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sim',
        showLoaderOnConfirm: true,
        preConfirm: () => {

          this.endereco_offiline_selecionado = null;
          this.LimparEndereco();

          var forDeletion = [];
          forDeletion.push(itemRemover);
          var enderecos = this.enderecos_offline.filter(item => !forDeletion.includes(item))
          this.enderecos_offline = enderecos;
          var ls = new SecureLS();
          ls.set('enderecos', enderecos);

          return true;
        },
        allowOutsideClick: () => !Swal.isLoading()
      }).then((result) => {
        if (result.value) {
          Swal.fire({
            title: 'Sucesso',
            text: 'Endereço removido',
            icon: 'success',
            customClass: {
              confirmButton: 'confirm-button-class cor-primaria-bg'
            }
          })
        }
      })
    },
    async SelecionarBairro() {
      var bairro = document.getElementById('selectbairro' + this.bairro_id);
      this.endereco.bairro = bairro.getAttribute('data-nome');
      if (this.$store.state.empresa.forma_cobranca_frete == 'BAIRRO') {
        await this.CalcularFrete('bairro=' + this.bairro_id);
      }
    },
    LimparEndereco() {
      this.forma_entrega = "ENTREGA";
      this.endereco.bairro = "";
      this.endereco.cep = "";
      this.endereco.cidade_nome = "";
      this.endereco.complemento = "";
      this.endereco.numero = "";
      this.endereco.endereco = "";
      this.endereco.uf = "RO";
      this.nao_tem_cep = false;
      this.novo_endereco = false;
      this.bairro_id = "";
    },
    PedidoValido() {
            if ((this.$store.state.pedido.itens.length <= 0)) {
        return false;
      }

      if (this.forma_entrega == "ENTREGA") {

        if (this.endereco.numero == null)
          this.endereco.numero = ""

        if (this.endereco.complemento == null)
          this.endereco.complemento = ""

        if (this.endereco_offiline_selecionado != null) {
          this.endereco_entrega_valido =
            (!this.taxa_entrega_calculo_mensagem_erro) && (this.endereco_offiline_selecionado.endereco != "") &&
            (this.endereco_offiline_selecionado.bairro_nome != "") &&
            (this.endereco_offiline_selecionado.complemento != "" || this.endereco_offiline_selecionado.numero) &&
            (this.endereco_offiline_selecionado.cidade_nome != "") &&
            (this.endereco_offiline_selecionado.uf != "");
        } else {
          if (this.$store.state.empresa.forma_cobranca_frete == 'FIXO') {
            this.taxa_entrega_calculo_mensagem_erro = false;
          }
          this.endereco_entrega_valido =
            (!this.taxa_entrega_calculo_mensagem_erro) && (this.endereco.endereco != "") &&
            (this.endereco.bairro != "") &&
            ((this.endereco.complemento != "") || (this.endereco.numero != "")) &&
            (this.endereco.uf != "") &&
            (this.endereco.cidade_nome != "");
        }

        this.troco_valido = ((this.precisa_troco && this.troco_para_quanto > this.$store.getters.pedidoTotal) || !this.precisa_troco);
      } else {
        this.endereco_entrega_valido = true;
        this.troco_valido = ((this.precisa_troco && this.troco_para_quanto > this.$store.getters.pedidoSubtotal) || !this.precisa_troco);
      }

      $('#troco_valor').removeClass('invalid');
      if (!this.troco_valido && this.troco_para_quanto > 0)
        $('#troco_valor').addClass('invalid');

      $('#telefone').removeClass('invalid');
      if (this.telefone != "" && this.telefone.length < 14)
        $('#telefone').addClass('invalid');

      $('#cpf').removeClass('invalid');
      if (this.cpf_nota && !ValidarCPF(this.cpf))
        $('#cpf').addClass('invalid');

      this.agendamento_valido = (!this.agendamento) || (this.data_agendamento != "" && this.hora_agendamento != "");

      this.dados_pessoa_valido = (this.nome_cliente != "") && (this.telefone.length >= 14) && (!this.cpf_nota || ValidarCPF(this.cpf));

      let enderecoValido = this.endereco_entrega_valido
      if(this.naoSeiEndereco && this.endereco.endereco.length > 3)
        enderecoValido = true;

      return (enderecoValido) && (this.forma_pagamento) &&
        (this.troco_valido) && (this.dados_pessoa_valido) && (this.agendamento_valido);
    },
    EnviarPedido() {
      if (!this.telefone) {
        Swal.fire({
          title: 'Aviso',
          text: 'Informe um telefone válido',
          icon: 'info',
          customClass: {
            confirmButton: 'confirm-button-class cor-primaria-bg'
          }
        })
        document.getElementById("telefone").focus();
        return false;
      }

      if (this.telefone.length < 14) {
        Swal.fire({
          title: 'Aviso',
          text: 'Informe um telefone válido',
          icon: 'info',
          customClass: {
            confirmButton: 'confirm-button-class cor-primaria-bg'
          }
        })
        document.getElementById("telefone").focus();
        return false;
      }

      if (!ValidarCPF(this.cpf)) {
        if (this.cpf_nota) {
          Swal.fire({
            title: 'Aviso',
            text: 'CPF Inválido!',
            icon: 'error',
            customClass: {
              confirmButton: 'confirm-button-class cor-primaria-bg'
            }
          })
          return false;
        } else {
          this.cpf = "";
        }
      }

      if (this.forma_entrega == "ENTREGA") {
        if (this.endereco_offiline_selecionado != null) {
          this.endereco.cep = this.endereco_offiline_selecionado.cep;
          this.endereco.uf = this.endereco_offiline_selecionado.uf;
          this.endereco.cidade_nome = this.endereco_offiline_selecionado.cidade_nome;
          this.bairro_id = this.endereco_offiline_selecionado.bairro_id;
          this.endereco.bairro = this.endereco_offiline_selecionado.bairro_nome;
          this.endereco.endereco = this.endereco_offiline_selecionado.endereco;
          this.endereco.numero = this.endereco_offiline_selecionado.numero;
          this.endereco.complemento = this.endereco_offiline_selecionado.complemento;
        } else {
          this.SalvarEndereco();
        }
      }

      this.SalvarDados();

      var pedido = this.$store.state.pedido;
      pedido.nome_cliente = this.nome_cliente;
      pedido.cpf = this.cpf;
      pedido.telefone = this.telefone;
      if (this.forma_entrega == "ENTREGA") {
        pedido.taxa_entrega = this.$store.state.empresa.taxa_entrega;
        pedido.taxa_retorno = this.ObterTaxaRetorno();
      }
      pedido.forma_pagamento = this.forma_pagamento;
      pedido.forma_entrega = this.forma_entrega;
      pedido.precisa_troco = this.precisa_troco ? 'S' : 'N';
      pedido.troco_para_quanto = this.troco_para_quanto;
      pedido.entrega_cep = this.endereco.cep;
      pedido.entrega_bairro = this.endereco.bairro;
      pedido.entrega_endereco = this.endereco.endereco;
      pedido.entrega_cidade = this.endereco.cidade_nome;
      pedido.entrega_uf = this.endereco.uf;
      pedido.entrega_numero = this.endereco.numero;
      pedido.entrega_complemento = this.endereco.complemento;
      pedido.valor_desconto = (parseFloat(this.$store.state.cupom_desconto_valor) + parseFloat(this.CalcularValorDescontoFormaPagamento())).toFixed(2);
      pedido.localizacao = localStorage.getItem('localizacao');
      pedido.cupom_desconto_codigo = this.cupom_desconto;

      if(this.forma_pagamento === 'PAGHIPER_PIX'){
        pedido.chave_pre_pagamento = this.paghiper_pix.chave_rastreamento;
      }
      if(this.forma_pagamento === 'SOFTEXPRESS_CARTAO'){
        pedido.chave_pre_pagamento = this.softexpress_cartao.pagamento_chave_rastreamento;
      }



      try{
        pedido.pedido_html = this.ObterHTMLdoPedido();
      }catch (e) {

      }

      this.$store.commit('pedido', pedido)

      // this.EnviarParaWhatsApp();
      // console.log(this.ObterHTMLdoPedido())

      let isPrePagamento = this.paghiper_pix.pagamento_realizado || this.softexpress_cartao.pagamento_realizado;

      Swal.fire({
        title: "Aviso",
        text: !isPrePagamento ? " Deseja confirmar este pedido?" : "Seu pagamento foi recebido!",
        icon: "info",
        customClass: {
          confirmButton: "confirm-button-class cor-primaria-bg",
        },
        showCancelButton: !isPrePagamento,
        cancelButtonText: "Cancelar",
        confirmButtonText: !isPrePagamento ? " Sim" : "Enviar Pedido",
        showLoaderOnConfirm: true,
        allowOutsideClick: () => false,
        preConfirm: () => {
          return $.ajax({
            url: this.$store.state.apiUrl + "pedidos/novo/empresa/" + this.$store.state.empresa_url,
            data: this.$store.state.pedido,
            type: "POST",
            success: (data) => {
              Swal.hideLoading();
              this.pedido_enviado = true;
              if (this.forma_pagamento == 'MERCADOPAGOLINK') {
                this.link_pagamento_chave_rastreamento = data[1];
                this.link_pagamento = data[2];
              }
              return true;
            },
            error: (data) => {
              var erro = "Erro ao enviar o seu pedido para o servidor";
              if (data.status < 500 && data.responseJSON.length > 0) {
                erro = data.responseJSON[0];
              }

              Swal.fire({
                title: 'Aviso!',
                text: erro,
                icon: 'error',
                customClass: {
                  confirmButton: 'confirm-button-class materialize-red'
                }
              });

              return false;
            }
          });
        }
      }).then((result) => {
        if (result.value) {
          Swal.fire({
            title: 'Sucesso',
            html: 'Obrigado ' + this.$store.state.pedido.nome_cliente + "!" + (this.$store.state.empresa.receber_pedidos_whatsapp == "S" ? "</br></br><b>Aguarde seu WhatsApp abrir e envie seu pedido!<b/>" : ""),
            icon: 'success',
            customClass: {
              confirmButton: 'confirm-button-class cor-primaria-bg'
            }
          }).then(res => {
            if (this.$store.state.empresa.receber_pedidos_whatsapp == "S") {
              this.EnviarParaWhatsApp();
            }
          }).catch(res => {
            if (this.$store.state.empresa.receber_pedidos_whatsapp == "S") {
              this.EnviarParaWhatsApp();
            }
          })
        }
      })
    },
    LimitarCaracteres(conteudo, tamanho) {
      var content = conteudo;
      var limit = parseInt(tamanho);
      if (content.length > limit) {
        return content.slice(0, limit) + '...'
      } else {
        return content + '';
      }
    },
    cpf_mask(v) {
      return v.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3\-\$4");
    },
    RemoverItem(item) {
      Swal.fire({
        title: 'Aviso',
        text: "Deseja realmente remover " + item.produto.nome,
        icon: 'warning',
        customClass: {
          confirmButton: 'confirm-button-class cor-primaria-bg'
        },
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
      }).then((result) => {
        if (result.value) {
          this.$store.commit('remover_item_pedido', item);

          this.$store.state.cupom_desconto_valor = 0.00;
          this.AplicarDesconto();

          Swal.fire({
            title: 'Removido!',
            text: 'Item removido do pedido.',
            icon: 'success',
            customClass: {
              confirmButton: 'confirm-button-class cor-primaria-bg'
            }
          })
        }
      })
    },
    RemoverAdicional(item, adicionalRemover) {
      Swal.fire({
        title: 'Aviso',
        text: "Deseja realmente remover " + adicionalRemover.nome,
        icon: 'warning',
        customClass: {
          confirmButton: 'confirm-button-class cor-primaria-bg'
        },
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
      }).then((result) => {
        if (result.value) {
          this.$store.commit('remover_item_adicional_pedido', {item: item, adicional: adicionalRemover});
          Swal.fire({
            title: 'Removido!',
            text: 'Item removido do pedido.',
            icon: 'success',
            customClass: {
              confirmButton: 'confirm-button-class cor-primaria-bg'
            }
          })
        }
      })
    },
    ObterValorFrete() {
      var valor = (parseFloat(this.$store.state.empresa.taxa_entrega)).toFixed(2);
      if (valor == "0.00") {
        return this.taxa_entrega_v2;
      } else {
        return 'R$ ' + valor;
      }
    },
    cep_mask(v) {
      return v.replace(/(\d{5})/g, "\$1-");
    },
    ObterHTMLdoPedido() {
      var pedidoStore = this.$store.state.pedido;
      let pedido = new WMCompose();

      pedido.writeText("------------------------------------<br>", 1);
      pedidoStore.itens.forEach(item => {
        pedido.writeText("<strong>" + item.quantidade + 'x ' + item.produto.nome + "</strong> - R$ " + (item.quantidade * parseFloat(item.produto.valor)).toFixed(2) + "<br>", 1);

        if(this.$store.state.empresa.mostrar_categoria_wpp == "S"){
          item.categorias.forEach(categoria => {
            pedido.writeText("  <strong>" + categoria.descricao + "</strong><br>", 1);
            categoria.adicionais.forEach(adicional => {
              pedido.writeText("    " + ((adicional.quantidade || 1) * item.quantidade) + 'x ' + adicional.nome + " - R$ " + (parseFloat(adicional.valor * (adicional.quantidade || 1)  * item.quantidade).toFixed(2)) + "<br>", 1);
            });
          });
        }
        else {
          item.adicionais.forEach(adicional => {
            pedido.writeText("    " + ((adicional.quantidade || 1) * item.quantidade) + 'x ' + adicional.nome + " - R$ " + (parseFloat(adicional.valor * (adicional.quantidade || 1)  * item.quantidade).toFixed(2)) + "<br>", 1);
          });
        }

        if(item.observacao_cliente)
          pedido.writeText("<strong>Obs:</strong> <i>" + item.observacao_cliente + "</i><br>", 1);
      });

      pedido.writeText("------------------------------------<br>", 1);

      pedido.writeText("<strong>Subtotal:</strong> R$ " + this.$store.getters.pedidoSubtotal.toFixed(2) + "<br>", 1, 1);

      if (this.$store.state.cupom_desconto_valor > 0)
        pedido.writeText("<strong>Cupom de Desconto:</strong> R$ " + parseFloat(this.$store.state.cupom_desconto_valor).toFixed(2) + "<br>", 1, 1);

      if (this.forma_entrega == "ENTREGA")
        pedido.writeText("<br><strong>Taxa de entrega:</strong> " + this.ObterValorFrete() + "<br>", 1, 1)

      if (this.ObterTaxaRetorno() > 0)
        pedido.writeText("<strong>Taxa de Retorno:</strong> R$ " + this.ObterTaxaRetorno().toFixed(2) + "<br>", 1, 1);

      if (this.CalcularValorDescontoFormaPagamento() > 0)
        pedido.writeText("<strong>Desconto (Pagamento):</strong> R$ " + parseFloat(this.CalcularValorDescontoFormaPagamento()).toFixed(2) + "<br>", 1, 1);

      pedido.writeText("<strong>Total:</strong> R$ " + this.ObterValorTotalAtualizadoDoPedido() + "<br>", 1)
      pedido.writeText("------------------------------------<br>", 1);
      pedido.writeText("<strong>Como deseja receber o pedido?</strong><br>", 1);
      pedido.writeText("<span>" + pedidoStore.forma_entrega + "</span><br>", 1);

      if (this.forma_entrega == 'ENTREGA') {
        pedido.writeText("<strong>Endereço de Entrega</strong><br>", 2);
        pedido.writeText(pedidoStore.entrega_endereco + ", " + (pedidoStore.entrega_numero || "S/N") + (pedidoStore.entrega_complemento ? " - " + pedidoStore.entrega_complemento : "") + "<br>", 1);
        pedido.writeText(pedidoStore.entrega_bairro + ", " + pedidoStore.entrega_cidade + "/" + pedidoStore.entrega_uf + "<br>", 1);
        if (pedidoStore.entrega_cep)
          pedido.writeText(this.cep_mask(pedidoStore.entrega_cep) + "<br>", 1);
      }

      pedido.writeText("<br><strong>Forma de Pagamento</strong><br>", 2);
      pedido.writeText("<span>" + this.FormatarFormaPagamento(pedidoStore.forma_pagamento) + "</span><br>", 1);

      if (pedidoStore.forma_pagamento == "MERCADOPAGOLINK") {
        pedido.writeText("<strong>Link de Pagamento</strong><br>", 2);
        pedido.writeText(this.link_pagamento + "<br>", 1);

        pedido.writeText("<strong>Visualizar Status do Pagamento</strong><br>", 2);
        pedido.writeText(this.$store.state.empresa.sirrus_delivery_link + "pagamentos/mercadopago/rastrear/" + this.link_pagamento_chave_rastreamento + "<br>", 1);
      }

      if (pedidoStore.forma_pagamento == "PIX") {
        pedido.writeText("<br><strong>PIX - Tipo:</strong><br>", 2);
        let forma_pagamento_texto_amigavel = '';
        switch (this.$store.state.empresa.pagamento_pix_chave_tipo) {
          case("CHAVE_ALEATORIA"):
            forma_pagamento_texto_amigavel = "Chave Aleatória";
            break;
          case("CELULAR"):
            forma_pagamento_texto_amigavel = "Celular";
            break;
          case("CPF_CNPJ"):
            forma_pagamento_texto_amigavel = "CPF/CNPJ";
            break;
          case("EMAIL"):
            forma_pagamento_texto_amigavel = "E-mail";
            break;
        }

        pedido.writeText("<span>" + forma_pagamento_texto_amigavel + "</span><br>", 1);

        pedido.writeText("<strong>PIX - Chave Pagamento:</strong><br>", 1);
        pedido.writeText("<span>" + this.$store.state.empresa.pagamento_pix_chave + "</span><br>", 1);
      }

      if (pedidoStore.precisa_troco == "S") {
        pedido.writeText("<strong>Precisa de troco?</strong><br><br>", 2);
        pedido.writeText("Sim, para R$" + pedidoStore.troco_para_quanto + "<br>", 1);
      }

      pedido.writeText("<strong>Cliente:</strong><br> " + pedidoStore.nome_cliente + "<br><br>", 2);
      pedido.writeText("<strong>Telefone:</strong><br> " + pedidoStore.telefone + "<br>", 1);
      if (this.cpf_nota)
        pedido.writeText("<strong>CPF:</strong><br> " + this.cpf_mask(pedidoStore.cpf) + "<br>", 1);

      return pedido.getText();
    },
    EnviarParaWhatsApp() {
      var pedidoStore = this.$store.state.pedido;
      let pedido = new WMCompose();
      pedido.writeText("*" + this.$store.state.empresa.nome + " - Novo Pedido*");
      pedido.writeText("---------------------------------", 1, 1);
      pedidoStore.itens.forEach(item => {
        pedido.writeText("*" + item.quantidade + 'x ' + item.produto.nome + "* - R$ " + (item.quantidade * parseFloat(item.produto.valor)).toFixed(2), 1);

        if(this.$store.state.empresa.mostrar_categoria_wpp == "S"){
          item.categorias.forEach(categoria => {
            pedido.writeText("  *" + categoria.descricao + "*", 1);
            categoria.adicionais.forEach(adicional => {
              pedido.writeText("    " + ((adicional.quantidade || 1) * item.quantidade) + 'x ' + adicional.nome + " - R$ " + (parseFloat(adicional.valor * (adicional.quantidade || 1)  * item.quantidade).toFixed(2)), 1);
            });
          });
        }
        else {
          item.adicionais.forEach(adicional => {
            pedido.writeText("    " + ((adicional.quantidade || 1) * item.quantidade) + 'x ' + adicional.nome + " - R$ " + (parseFloat(adicional.valor * (adicional.quantidade || 1)  * item.quantidade).toFixed(2)), 1);
          });
        }

        if(item.observacao_cliente)
          pedido.writeText("*Obs:* _" + item.observacao_cliente + "_", 1);
      });

      pedido.writeText("*Subtotal:* R$ " + this.$store.getters.pedidoSubtotal.toFixed(2), 2, 1);

      if (this.$store.state.cupom_desconto_valor > 0)
        pedido.writeText("*Cupom de Desconto:* R$ " + this.$store.state.cupom_desconto_valor, 1, 1);

      if (this.forma_entrega == "ENTREGA")
        pedido.writeText("*Taxa de entrega:* " + this.ObterValorFrete(), 1, 1)

      if (this.ObterTaxaRetorno() > 0)
        pedido.writeText("*Taxa de Retorno:* R$ " + this.ObterTaxaRetorno().toFixed(2), 1, 1);

      if (this.CalcularValorDescontoFormaPagamento() > 0)
        pedido.writeText("*Desconto (Pagamento):* R$ " + parseFloat(this.CalcularValorDescontoFormaPagamento()).toFixed(2), 1, 1);

      pedido.writeText("*Total: R$ " + this.ObterValorTotalAtualizadoDoPedido() + "*", 1);

      //pedido.writeText("*Total:* R$ " + this.$store.getters.pedidoTotal, 1, 1)

      // pedido.writeText("*Total:* R$ " + (this.forma_entrega == 'ENTREGA' ? this.$store.getters.pedidoTotal : this.$store.getters.pedidoSubtotal).toFixed(2), 1, 1)
      pedido.writeText("---------------------------------", 1, 1);
      pedido.writeText("*Como deseja receber o pedido?*", 1);
      pedido.writeText("```" + pedidoStore.forma_entrega + "```", 1, 1);

      if (this.forma_entrega == 'ENTREGA') {
        pedido.writeText("*Endereço de Entrega*", 1);
        pedido.writeText(pedidoStore.entrega_endereco + ", " + pedidoStore.entrega_numero + " - " + pedidoStore.entrega_complemento + " " + pedidoStore.entrega_bairro + ", " + pedidoStore.entrega_cidade + "/" + pedidoStore.entrega_uf, 1)
        pedido.writeText(" " + pedidoStore.entrega_cep, 1, 1);
      }

      pedido.writeText("*Forma de Pagamento*", 1, 1);
      pedido.writeText("```" +  this.FormatarFormaPagamento(pedidoStore.forma_pagamento) + "```", 0, 1);

      if (pedidoStore.forma_pagamento == "MERCADOPAGOLINK") {
        pedido.writeText("*Link de Pagamento*", 2);
        pedido.writeText(this.link_pagamento, 1);

        pedido.writeText("*Visualizar Status do Pagamento*", 2);
        pedido.writeText(this.$store.state.empresa.sirrus_delivery_link + "pagamentos/mercadopago/rastrear/" + this.link_pagamento_chave_rastreamento, 1);
      }

      if (pedidoStore.forma_pagamento == "PIX") {
        pedido.writeText("*PIX - Tipo:*", 2);
        let forma_pagamento_texto_amigavel = '';
        switch (this.$store.state.empresa.pagamento_pix_chave_tipo) {
          case("CHAVE_ALEATORIA"):
            forma_pagamento_texto_amigavel = "Chave Aleatória";
            break;
          case("CELULAR"):
            forma_pagamento_texto_amigavel = "Celular";
            break;
          case("CPF_CNPJ"):
            forma_pagamento_texto_amigavel = "CPF/CNPJ";
            break;
          case("EMAIL"):
            forma_pagamento_texto_amigavel = "E-mail";
            break;
        }

        pedido.writeText("```" + forma_pagamento_texto_amigavel + "```", 1);

        pedido.writeText("*PIX - Chave Pagamento:*", 1);
        pedido.writeText("```" + this.$store.state.empresa.pagamento_pix_chave + "```", 1);
      }

      if (pedidoStore.precisa_troco == "S") {
        pedido.writeText("*Precisa de troco?*", 1);
        pedido.writeText("Sim, para R$" + pedidoStore.troco_para_quanto, 1, 1);
      }
      pedido.writeText("*Nome*", 1);
      pedido.writeText(pedidoStore.nome_cliente, 1, 1);

      pedido.writeText("*Telefone*", 1);
      pedido.writeText(pedidoStore.telefone, 1, 1);

      if (this.cpf_nota) {
        pedido.writeText("*CPF*", 1);
        pedido.writeText(this.cpf_mask(pedidoStore.cpf), 1, 1);
      }

      var horaAtual = new Date();
      var strHoraAtual = ("0" + horaAtual.getHours()).slice(-2) + ":" + ("0" + horaAtual.getMinutes()).slice(-2);

      pedido.writeText("_Pedido recebido por " + this.$store.state.empresa.nome + " às  " + strHoraAtual + "_", 1);

      // console.log(pedido.getText());
      WMSend(this.$store.state.empresa.whatsapp, pedido.getText());

      setTimeout(() => {
        location.reload();
      }, 700)
    },
    maxLengthCheck() {
      if (this.endereco.cep.length > 8)
        this.endereco.cep = this.endereco.cep.slice(0, 8)
    }
  }
}
</script>


<style scoped>
.btn {
  height: 20px;
  line-height: 13px;
  font-size: 11px;
}

td, th {
  padding: 3px 5px;
  display: table-cell;
  text-align: left;
  vertical-align: middle;
  border-radius: 2px;
}

.bloco {
  margin: 10px auto;
}

.content-e {
  text-align: center;
}

.inner-e {
  display: inline-block;
}

.valid-badge {
  position: absolute;
  top: 10px;
  right: 12px;
}

.valid-check {
  position: absolute;
  top: 2px;
  right: 12px;
}

.btn{
  height: 20px;
  line-height: 13px;
  font-size: 11px;
}
td, th {
  padding: 3px 5px;
  display: table-cell;
  text-align: left;
  vertical-align: middle;
  border-radius: 2px;
}
.bloco{
  margin: 10px auto;
}
.content-e
{
  text-align: center;
}
.inner-e
{
  display:inline-block;
}
.tb.itens {
  border-bottom: 1px solid;
}
.tb.itens.lista {
  padding: 4px 10px;
}
.btn-enviar {
  width: 100%;
  padding: 0 8px;
}
.btn-enviar > span {
  margin-right: 12px;
}

.row .col.s4 {
  margin-left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Paginas/Pedido.vue